export default __webpack_public_path__ + "static/media/reply_off.a1e16bd6.svg";